var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallWhitePuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2355 3.082C10.013 3.30444 9.63136 3.37209 9.40893 3.14966L8.4426 2.18333C8.19816 1.93889 7.80184 1.93889 7.5574 2.18333L6.59107 3.14966C6.36864 3.3721 5.98698 3.30444 5.76455 3.082C5.02378 2.34124 3.82277 2.34124 3.082 3.082C2.34124 3.82277 2.34124 5.02378 3.082 5.76455C3.30444 5.98698 3.3721 6.36864 3.14967 6.59107L2.18333 7.5574C1.93889 7.80184 1.93889 8.19816 2.18333 8.4426L3.14966 9.40893C3.37209 9.63136 3.75375 9.5637 3.97619 9.34127C4.71695 8.60051 5.91796 8.6005 6.65873 9.34127C7.39949 10.082 7.39949 11.2831 6.65873 12.0238C6.4363 12.2462 6.36864 12.6279 6.59107 12.8503L7.5574 13.8167C7.80184 14.0611 8.19816 14.0611 8.4426 13.8167L9.40893 12.8503C9.63136 12.6279 10.013 12.6956 10.2355 12.918C10.9762 13.6588 12.1772 13.6588 12.918 12.918C13.6588 12.1772 13.6588 10.9762 12.918 10.2355C12.6956 10.013 12.6279 9.63136 12.8503 9.40893L13.8167 8.4426C14.0611 8.19816 14.0611 7.80184 13.8167 7.5574L12.8503 6.59107C12.6279 6.36864 12.6956 5.98698 12.918 5.76455C13.6588 5.02378 13.6588 3.82277 12.918 3.082C12.1772 2.34124 10.9762 2.34124 10.2355 3.082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallWhitePuzzle);
export default __webpack_public_path__ + "static/media/smallWhitePuzzle.39ee781db726f87ef7dc485ba83b1f9b.svg";
export { ForwardRef as ReactComponent };